export class CalendarSummaryFilter {
  public date: String;
  public salesman_ids: String[];
}

export class DaySumaryOfCalendarPlanning {
  public client_count: number;
  public visit_date: string;
}
